module.exports = __webpack_public_path__ + "media/images/brands/mundo_ripilica-b228f704efe2e1a59a71f52a0cb17a69.png";